import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";

export const fmtOfferDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long" }) : "";

// Home-page strip for the autumn offer: FREE bifold (any) doors.
export function AutumnOfferBanner({ offers }) {
  if (!offers?.free_doors_active) return null;
  return (
    <Link to="/quote" data-testid="home-autumn-banner" className="block bg-[#12263A] text-white hover:bg-[#0F1F30] transition-colors">
      <div className="px-4 sm:px-6 md:px-12 lg:px-16 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center">
        <span className="inline-flex items-center gap-2 text-[10px] sm:text-[11px] font-black uppercase tracking-[0.2em] text-[#C79A3B] shrink-0">
          <Gift size={15} /> Autumn offer
        </span>
        <span className="text-sm md:text-base font-bold leading-snug" data-testid="home-autumn-doors">
          <span className="text-[#C79A3B]">FREE bifold doors</span> on every extension booked before {fmtOfferDate(offers.free_doors_until) || "1 December"}. Prefer French doors? Also free.
        </span>
        <ArrowRight size={16} className="shrink-0 hidden sm:block text-[#C79A3B]" />
      </div>
    </Link>
  );
}
